import { Box, Container } from "@mui/material";

export default function UserAdminLayout({ children }) {
  return (
    <Box sx={{ bgcolor: "#ddeeff" }}>
      <Container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          // padding: 0,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {children}
        </Box>
      </Container>
    </Box>
  );
}
